// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-row-hover:hover > td {
  background-color: #f8f9fa !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admadd/styles/admadd.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;AACJ","sourcesContent":[".table-row-hover:hover > td {\r\n    background-color: #f8f9fa !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
